import { Component, computed } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { SidebarComponent } from "../layout/sidebar/sidebar.component";
import { HeaderComponent } from "../layout/header/header.component";
import { JniToastrComponent } from "../shared/components/jni-toastr/jni-toastr.component";
import { MessageService } from "primeng/api";
import { JniToastrService } from "../core/services/jni-toastr.service";
import { SidebarService } from "../core/services/sidebar.service";

@Component({
  selector: "jni-modules",
  standalone: true,
  styleUrl: "./module.component.scss",
  imports: [
    CommonModule,
    RouterModule,
    SidebarComponent,
    HeaderComponent,
    JniToastrComponent,
  ],
  template: `
    <div class="wrapper row">
      <jni-toastr></jni-toastr>
      <div
        class="sidebar position-relative col-lg-2 pr-0"
        [ngClass]="{ collapsed: isSidebarCollapsed() }">
        <jni-sidebar (collapseChange)="onCollapseChange($event)"></jni-sidebar>
      </div>

      <div class="col pr-0 right-section">
        <div class="row">
          <jni-header></jni-header>
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  `,
  providers: [MessageService, JniToastrService],
})
export class ModulesComponent {
  isSidebarCollapsed = computed(() => this.sidebarService.isCollapsed$());

  constructor(private sidebarService: SidebarService) {}

  onCollapseChange(collapseState: boolean) {
    this.sidebarService.setSidebarState(collapseState);
  }
}
